import { useMemo } from 'react';

import type {
	UsePageIncludeMacroParamsProps,
	UsePageIncludeMacroParamsResult,
} from '../pageIncludeMacroTypes.ts';
import { parseMacroTarget } from '../util/pageIncludeMacroParams.ts';

/**
 * Processes macro props and params into structured values for the renderer component.
 * Handles macro parameter parsing only — GraphQL query target selection and fetching are separate.
 */
export const usePageIncludeMacroParams = ({
	macroDefaultProps,
	macroParams,
}: UsePageIncludeMacroParamsProps): UsePageIncludeMacroParamsResult => {
	const parsedTarget = useMemo(() => parseMacroTarget(macroParams), [macroParams]);
	const macroId = macroDefaultProps.attributes?.macroId ?? undefined;
	const hostContentId: string = macroDefaultProps.contentId ?? '';

	return {
		parsedTarget,
		macroId: macroId ? `${macroId}` : undefined,
		hostContentId,
	};
};
